module.exports = __webpack_public_path__ + "assets/57a3ea6c7e7bd5d62adb90c8b27d9f7a.mp3";